module.exports = __webpack_public_path__ + "img/quote.fe9d07c8.svg";